import React from "react";
import useScript from "hooks/useScript";
import { getEnvironment, loadAssetsCdnUrl } from "utils/env";
import appConfig from "../config.json";
import { loadBrandParam } from "./common";

const { cdn, externalScripts, environments } = appConfig;

const env = getEnvironment();
const brand = loadBrandParam();

const ExternalScript = ({ scriptName, cdnAssetsUrl, env, brand }) => {
	const {
		fileName,
		position = "head",
		enviromentParamsByBrand = false,
	} = externalScripts[scriptName];
	let scriptUrl = `${cdnAssetsUrl}/media/layout/assets/scripts/${fileName}.js`;

	if (enviromentParamsByBrand) {
		const params = environments[env].brands[brand][scriptName];
		const queryParams = new URLSearchParams(params);
		scriptUrl += `?${queryParams.toString()}`;
	}
	useScript(scriptUrl, position);
	return null;
};

export const ExternalScripts = () => {
	const cdnAssetsUrl = loadAssetsCdnUrl(`${cdn?.baseUrl}`, env);
	return (
		<>
			{Object.keys(externalScripts).map((scriptName) => (
				<ExternalScript
					key={scriptName}
					scriptName={scriptName}
					cdnAssetsUrl={cdnAssetsUrl}
					env={env}
					brand={brand}
				/>
			))}
		</>
	);
};
